module.exports = __webpack_public_path__ + "static/media/1003860_549371575128792_1828753979_n.ab8704cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/1003860_549371575128792_1828753979_n.jpg
// module id = 335
// module chunks = 0